export enum EServiceStatus {
    LOADING = 'loading',
    LOADED = 'loaded',
    ERROR = 'error',
}
